const resolve = data => Promise.resolve({
  ok: true,
  data
})

let token
export default {
  setToken: t => token = t,
  verify: () => new Promise((resolve, reject) => resolve({
    ok: !!token
  })),
  fetchIgrejas: () => resolve([{
    id: 6,
    descricao: 'Igreja 1'
  }, {
    id: 5,
    descricao: 'Igreja 2'
  }, {
    id: 4,
    descricao: 'Igreja 3'
  }]),
  fetchCelulas: () => {
    return resolve([{
      id: 1,
      descricao: 'Célula de teste roxa',
      telefone: 4430308899,
      email: 'email@email.com',
      labels: ['roxa', 'crianças'],
      diaHora: 'QUARTA - 20:30',
      igreja: {
        id: 5,
        descricao: 'Igreja 2'
      },
      endereco: {
        country: null,
        formalCode: null,
        information: null,
        latitude: -23.43144,
        localization: "SARANDI",
        longitude: -51.86212,
        neighbourhood: "JARDIM INDEPENDÊNCIA",
        number: "1466",
        premisse: "LONDRINA ",
        premisseType: "AVENIDA",
        state: "PR",
        stateCode: null,
        zipCode: "87114010",
      }
    }, {
      id: 2,
      descricao: 'Célula de teste azul',
      telefone: 4430308899,
      igreja: {
        id: 6,
        descricao: 'Igreja 1'
      },
      labels: ['azul', 'adultos'],
      diaHora: 'QUARTA - 20:30',
      email: 'email@email.com',
      endereco: {
        country: null,
        formalCode: null,
        information: null,
        latitude: -23.43844,
        localization: "SARANDI",
        longitude: -51.86812,
        neighbourhood: "JARDIM INDEPENDÊNCIA",
        number: "1466",
        premisse: "LONDRINA ",
        premisseType: "RUA",
        state: "PR",
        stateCode: null,
        zipCode: "87114010",
      }
    }, {
      id: 3,
      descricao: 'Célula amarela',
      telefone: 4430308899,
      labels: ['amarelo', 'adultos'],
      diaHora: 'QUARTA - 20:30',
      email: 'email@email.com',
      igreja: {
        id: 5,
        descricao: 'Igreja 2'
      },
      endereco: {
        country: null,
        formalCode: null,
        information: null,
        latitude: -23.4103353,
        localization: "SARANDI",
        longitude: -51.9476806,
        neighbourhood: "JARDIM INDEPENDÊNCIA",
        number: "1466",
        premisse: "LONDRINA ",
        premisseType: "AVENIDA",
        state: "PR",
        stateCode: null,
        zipCode: "87114010",
      }
    }, {
      id: 4,
      descricao: 'Célula marte',
      telefone: 4430308899,
      diaHora: 'QUARTA - 20:30',
      labels: ['amarelo', 'adultos'],
      email: 'email@email.com',
      igreja: {
        id: 4,
        descricao: 'Céu'
      },
      endereco: {
        country: null,
        formalCode: null,
        information: null,
        latitude: -23.4133333,
        localization: "SARANDI",
        longitude: -51.9436426,
        neighbourhood: "JARDIM INDEPENDÊNCIA",
        number: "1466",
        premisse: "LONDRINA ",
        premisseType: "AVENIDA",
        state: "PR",
        stateCode: null,
        zipCode: "87114010",
      }
    }])
  }
}



// WEBPACK FOOTER //
// ./src/Fixtures/index.js